import { render, staticRenderFns } from "./prop-status.vue?vue&type=template&id=8e5d4464&"
import script from "./prop-status.vue?vue&type=script&lang=ts&"
export * from "./prop-status.vue?vue&type=script&lang=ts&"
import style0 from "./prop-status.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports